var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangedView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0859 6.18746C14.888 6.18746 15.5747 5.90187 16.1458 5.33069C16.717 4.75951 17.0026 4.07288 17.0026 3.27079C17.0026 2.46871 16.717 1.78208 16.1458 1.2109C15.5747 0.639716 14.888 0.354126 14.0859 0.354126C13.2839 0.354126 12.5972 0.639716 12.026 1.2109C11.4549 1.78208 11.1693 2.46871 11.1693 3.27079C11.1693 4.07288 11.4549 4.75951 12.026 5.33069C12.5972 5.90187 13.2839 6.18746 14.0859 6.18746ZM18.4609 29.5208V10.5625H27.2109V7.64579H0.960934V10.5625H9.71094V29.5208H12.6276V20.7708H15.5443V29.5208H18.4609Z",
    fill: "#C4C5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4606 14.9375C40.6273 14.9375 16.7106 21.9375 3.29395 16.6875",
    stroke: "#00D084",
    strokeWidth: 2.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 14.3541L2.1276 16.1041L5.04427 21.9375",
    stroke: "#00D084",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangedView);
export default __webpack_public_path__ + "static/media/ChangedView.bb8dda1dc75d4e5526941bd84d9f188e.svg";
export { ForwardRef as ReactComponent };